import React from "react";
import { McModal } from "@maersk-global/mds-react-wrapper/mc-modal";

const NextStepModal = ({
  open,
  onClose,
  width = "50vw",
  height = "50vh",
  children,
}) => {
  return (
    <McModal
      heading="Please select the next step to proceed"
      open={open}
      closed={onClose}
      width={width}
      height={height}
    >
      {children}
    </McModal>
  );
};

export default NextStepModal;
